import React, { useState, useEffect, useRef } from 'react'
import Header from '../layout/header'
import DatePicker from "react-datepicker";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { MdKeyboardArrowLeft } from "react-icons/md";
import { useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import Pagination from "react-js-pagination";
import BannerImg from "../assets/images/admin-banner.webp"
import { FiSearch } from "react-icons/fi";
import { RiDeleteBinLine } from "react-icons/ri";
import { MdOutlineEdit } from "react-icons/md";
import { FaImage, FaVideo } from "react-icons/fa";
import noData from "../assets/images/no-data.png"
import Loader from "../assets/images/loader.gif"
import moment from 'moment';
import { apiCallingPost } from "../api/services"
import GenerateTag from './generate-tag';
import Videomultipleupload from './video-multiple-upload';
import ListUpload from '../pages/home/list-upload';
import ImagePopups from './image-popup';
import { IoCloseOutline } from "react-icons/io5";
import { ProgressBar } from "react-bootstrap"; // or use a custom div-based progress bar
function VideoList() {
  const location = useLocation();
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const { userData } = useSelector((state) => state.masterData)
  const { isAuthenticated } = useSelector((state) => state.authentication);
  const { getCloudBucketData } = useSelector((state) => state.getCloudBucketDetails)
  const [videoList, setVideoList] = useState([])
  const [videoListCount, setVideoListCount] = useState("")
  const [activePage, setActivePage] = useState(1)
  const [offset, setOffset] = useState(0)
  const [itemsCountPerPage, setItemsCountPerPage] = useState(10)
  const [proessedPopup, SetProessedPopup] = useState(false)
  const [processedVideoId, setProcessedVideoId] = useState("")
  const [userName, setUserName] = useState("")
  const [videoName, setVideoName] = useState("")
  const [loading, setLoading] = useState(false)
  const [searchFlag, setSearchFlag] = useState(false)
  const [popupList, SetPopupList] = useState(false)
  const [mode, SetMode] = useState("")
  const [selectIndex, setSelectIndex] = useState("")
  const [selectData, setSelectData] = useState([])
  const [fileType, setFileType] = useState("")
  const [mediaListFlag, setMediaListFlag] = useState(false)
  const [ImagePopup, setImagePopupFlag] = useState(false);
  const [popupSelectData, setPopupSelectData] = useState([]);
  const [deleteMultiFlag, setDeleteMultiFlag] = useState(false);
  const [tagMultiFlag, setTagMultiFlag] = useState(false);

  // Use a Set for selected videos for better performance
  const [allSelectedVideos, setAllSelectedVideos] = useState([]);
  const [allVideoIds, setAllVideoIds] = useState([]); // Store all video IDs
  const [isDragFile, setIsDragFile] = useState(false)
  const [isDelete, setIsDelete] = useState(false)
  const [selectedToDelete, setSelectedToDelete] = useState(null);
  const [deleteMode, setDeleteMode] = useState("");
  const [progressMap, setProgressMap] = useState({}); // { video_id: progressValue }
  const pollingRef = useRef(null);
  useEffect(() => {
    searchVideos()
    getAllId(userName, videoName, startDate, endDate, 0, fileType)
    videoListFn(userName, videoName, startDate, endDate, 0, fileType,true);
  }, [userName, videoName, startDate, endDate, searchFlag, mediaListFlag, fileType]);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgressMap((prev) => {
        const updated = { ...prev };

        videoList.forEach((video) => {
          if (video.videoStatus === "Processing") {
            const current = updated[video.video_id] || 0;
            if (current < 95) { 
              updated[video.video_id] = current + 5; // fake progress
            }
          } else if (video.videoStatus === "Processed") {
            updated[video.video_id] = 100;
          }
        });

        return updated;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [videoList]);
  useEffect(() => {
    if (!isAuthenticated) {
      window.location.href = "/login"
    }

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        cancelPopup();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [])
 // Watch for videos with "not uploaded" status and poll every 20s


 
 useEffect(() => {
  let intervalId;

  const hasPending = videoList.some(
    (video) => video.videoStatus !== "Processed" // adjust to your final status
  );

  if (hasPending) {
    // Start polling
    intervalId = setInterval(() => {
      // console.log('looping..................');
      
      videoListFn(userName, videoName, startDate, endDate, 0, fileType,false);
    }, 20000);
  }

  return () => {
    // Cleanup (stop polling)
    if (intervalId) {
      clearInterval(intervalId);
    }
  };
}, [videoList]);





  const searchVideos = () => {
    setOffset(0);
    setActivePage(1);
    // Clear selections when searching
  };

  const popupTagShow = (data) => {
    setImagePopupFlag(true)
    setPopupSelectData(data)
    document.body.style.overflow = 'hidden';
  }

  const videoListFn = async (userName, videoName, startDate, endDate, offset, fileType,isLoader) => {
    if (startDate && endDate && (endDate < startDate)) {
      toast.warning("To date must be greater than or equal to start date.")
      setEndDate("")
    } else {
      let postData = {}
      let url = ""
      if (userData?.roleDisplayName === "Admin") {
        postData = {
          offset: offset,
          max: itemsCountPerPage,
          videoName: videoName,
          videoApprovedStatus: "",
          fromDate: startDate ? moment(startDate).format('YYYY-MM-DD') : "",
          toDate: endDate ? moment(endDate).format('YYYY-MM-DD') : "",
          userId: userData.userId || "",
          adminName: userName,
          file_type_id: fileType
        }
        url = "api/video/videoList"
      }
      else {
        if(isLoader === true){
          setLoading(true)
        }        
        postData = {
          offset: offset,
          max: itemsCountPerPage,
          videoNameSearch: videoName,
          userNameSearch: userName,
          fromDate: startDate ? moment(startDate).format('YYYY-MM-DD') : "",
          toDate: endDate ? moment(endDate).format('YYYY-MM-DD') : "",
          user_id: "",
          videoUploadedBy: location?.state || "",
          file_type_id: fileType
        }
        url = "api/video/approvedVideoList"
      }
      try {
        let destinationListArray = []
        const response = await apiCallingPost(url, postData);
        const { data } = response;
        if (data.success === "1") {
          if (userData?.roleDisplayName === `Admin`) {
            destinationListArray = data.dataArray
          }
          else {
            destinationListArray = data.result
          }
          setVideoList(destinationListArray)
          setVideoListCount(Number(data.totalCount))
        }
        else {
          toast.warning(data.errorMessage);
          setVideoList([])
          setVideoListCount(0)
        }
      } catch (error) {
        console.error("Error: ", error);
        setVideoList([])
        setVideoListCount(0)
      } finally {
        setLoading(false);
      }
    }
  }


  const getAllId = async (userName, videoName, startDate, endDate, offset, fileType) => {
    let postData = {}
    let url = ""
    if (userData?.roleDisplayName === "Admin") {
      postData = {
        offset: offset,
        max: "",
        videoName: videoName,
        videoApprovedStatus: "",
        fromDate: startDate ? moment(startDate).format('YYYY-MM-DD') : "",
        toDate: endDate ? moment(endDate).format('YYYY-MM-DD') : "",
        userId: userData.userId || "",
        adminName: userName,
        file_type_id: fileType
      }
      url = "api/video/videoList"
    }
    else {
      postData = {
        offset: offset,
        max: "",
        videoNameSearch: videoName,
        userNameSearch: userName,
        fromDate: startDate ? moment(startDate).format('YYYY-MM-DD') : "",
        toDate: endDate ? moment(endDate).format('YYYY-MM-DD') : "",
        user_id: "",
        videoUploadedBy: location?.state || "",
        file_type_id: fileType
      }
      url = "api/video/approvedVideoList"
    }
    try {
      let destinationListArray = []
      const response = await apiCallingPost(url, postData);
      const { data } = response;
      if (data.success === "1") {
        if (userData?.roleDisplayName === `Admin`) {
          destinationListArray = data.dataArray
        }
        else {
          destinationListArray = data.result
        }
        setAllVideoIds(destinationListArray)
      }
      else {
        setAllVideoIds([])
      }
    } catch (error) {
      toast.error("Error: ", error);
    }

  }

  const handlePageChange = (pageNumber) => {
    let offsetNo = (pageNumber - 1) * itemsCountPerPage;
    setOffset(offsetNo);
    setActivePage(pageNumber);
    videoListFn(userName, videoName, startDate, endDate, offsetNo, fileType,true);
  }

  const generateTagPopup = async (ids, index, mode, video) => {
    if (mode == "multiple") {
      setTagMultiFlag(true);
      // Clear selected videos when processing starts
      setAllSelectedVideos([]);
    }

    if (video && (!video.video_heading || !video.description)) {
      toast.warning("Please fill name and description.");
      return;
    }

    // Update video status to "Processing"
    setVideoList(prevList =>
      prevList.map(obj =>
        ids.includes(obj.video_id) ? { ...obj, videoStatus: "Processing" } : obj
      )
    );

    let postData = { videoId: ids };
    try {
      if (mode === "multiple") {
        setTagMultiFlag(false);
        setAllSelectedVideos([])
      }
      const response = await apiCallingPost("api/common/generateTagBulkUpload", postData);
      let { data } = response;
      if (data.success === "1") {
      }
      else {
        console.error(data.result);
      }
    } catch (error) {
      console.error(error);
    } finally {
      videoListFn(userName, videoName, startDate, endDate, offset, fileType,true);
    }
  }

  const proessedDetailsPopup = async (data) => {
    document.body.style.overflow = 'hidden';
    SetProessedPopup(true)
    setProcessedVideoId(data.video_id)
  }

  const deleteList = async (videoIds) => {
    if (deleteMode === "multiple") setDeleteMultiFlag(true);

    // if (window.confirm("Do you want to delete?")) {
      let postData = {
        videoIds: selectedToDelete, // Already an array
        userId: userData.userId
      };
      try {
        const { data } = await apiCallingPost("api/video/deleteVideo", postData);
        if (data.success === "1") {
          toast.success(data.successMessage);
          // Remove deleted items from selection
          // setAllSelectedVideos(prev => 
          //   prev.filter(id => !videoIds.includes(id))
          // );
        } else {
          toast.error(data.errorMessage);
        }
      } catch (error) {
        console.error("Error Deleting Video:", error);
      } finally {
        let offsetCount = 0
        if ((videoListCount - 1) > ((activePage - 1) * itemsCountPerPage)) {
          offsetCount = offset
        }
        else {
          offsetCount = offset - itemsCountPerPage
        }
        setTimeout(() => {
          setOffset(offsetCount)
          setDeleteMultiFlag(false)
          setAllSelectedVideos([])
          videoListFn(userName, videoName, startDate, endDate, offsetCount, fileType,true);
        }, 1000);
      }
      deletePopupCancel()
    // } else {
    //   setDeleteMultiFlag(false);
    // }
  }

  const handleSelectAllChange = (e) => {
    const currentPageIds = allVideoIds
      .filter(item => item.videoStatus !== "Processing")
      .map(item => item.video_id);

    if (e.target.checked) {
      setAllSelectedVideos(prev => [
        ...new Set([...prev, ...currentPageIds])
      ]);
    } else {
      setAllSelectedVideos(prev =>
        prev.filter(id => !currentPageIds.includes(id))
      );
    }
  };

  const isAllChecked = () => {
    const currentPageIds = allVideoIds
      .filter(item => item.videoStatus !== "Processing")
      .map(item => item.video_id);

    return currentPageIds.length > 0 &&
      currentPageIds.every(id => allSelectedVideos.includes(id));
  };

  const isSomeChecked = () => {
    const currentPageIds = allVideoIds
      .filter(item => item.videoStatus !== "Processing")
      .map(item => item.video_id);

    return currentPageIds.some(id => allSelectedVideos.includes(id)) &&
      !isAllChecked();
  };

  const handleCheckboxChange = (e, video_id) => {
    if (e.target.checked) {
      // Add to selection
      setAllSelectedVideos(prev => [...prev, video_id]);
    } else {
      // Remove from selection
      setAllSelectedVideos(prev => prev.filter(id => id !== video_id));
    }
  };

  const cancelPopup = () => {
    SetPopupList(false)
    SetProessedPopup(false)
    setImagePopupFlag(false)
    setIsDragFile(false)
    document.body.style.overflow = 'auto';
  }


  const listPopup = (data, mode, index) => {
    SetPopupList(true)
    SetMode(mode)
    setSelectIndex(index)
    setSelectData(data)
    document.body.style.overflow = 'hidden';
  }

  const sendMail = async (mailData) => {
    let postData = {
      functionName: "sendMailToUsers",
      jsonMailOptions: mailData
    }
    try {
      const response = await apiCallingPost(postData);
      const { data } = response;
      if (data.success === "1") {

      }
    } catch (error) { }
  }
  const deletePopupCancel = () => {
    setIsDelete(false)
    setSelectedToDelete(null);
    setDeleteMode("")
  }

  return (
    <div className='home-wrapper main-wrapper  main-wrapper-cms video-list position-relative'>
      <ToastContainer />
      <Header setMediaListFlag={setMediaListFlag} mediaListFlag={mediaListFlag} />
      <div className=' banner-admin'>
        <div className='banner-admin-div'>
          <img className='img-fluid banner-admin-img' src={BannerImg} alt='Banner image' width={"100%"} height={500} />
        </div>
        <div className='search-wrapper'>
          <div className='container'>
            <div className='search-sub-wrap'>
              <div className="d-flex w-100 justify-content-end gap-10">
                <div className='banner-title-admin'>
                  Media List
                </div>
                <div className='search-section'>
                  <div className='search-div'>
                    <input type='text' className='search-input' placeholder='Name / Email Search'
                      onChange={(e) => {
                        setUserName(e.target.value)
                      }} />
                  </div>
                </div>
                <div className='search-section'>
                  <div className='search-div'>
                    <input type='text' className='search-input' placeholder='Title Search'
                      onChange={(e) => {
                        setVideoName(e.target.value)
                      }} />
                  </div>

                </div>
                <div className='search-section'>
                  <div className='search-div'>
                    <select name="" id="" className='search-input' onChange={(e) => setFileType(e.target.value)}>
                      <option value="">All</option>
                      <option value="1">Image</option>
                      <option value="2">Video</option>
                    </select>
                  </div>

                </div>
                <div className='search-section'>
                  <div className='search-div  from-date-search'>
                    <DatePicker selected={startDate} className='search-input' placeholderText="From Date"
                      onChange={(date) => {
                        setStartDate(date)
                      }}
                      calendarClassName="custom-calendar"
                      renderCustomHeader={({
                        date,
                        decreaseMonth,
                        increaseMonth,
                        prevMonthButtonDisabled,
                        nextMonthButtonDisabled,
                      }) => (
                        <div className="custom-header">
                          <div className="custom-header-top">
                            <div className="day">
                              {date.toLocaleDateString("en-US", {
                                weekday: "short",
                                month: "short",
                                day: "numeric",
                              })}
                            </div>
                          </div>
                          <div className="custom-month-nav">

                            <span className="month-year">
                              {date.toLocaleString("default", { month: "long" })} {date.getFullYear()}
                            </span>
                            <div>
                              <span onClick={decreaseMonth} disabled={prevMonthButtonDisabled} className="btn-picker">
                                <MdKeyboardArrowLeft color="#fff" size={25} />
                              </span>
                              <span onClick={increaseMonth} disabled={nextMonthButtonDisabled} className="btn-picker">
                                <MdOutlineKeyboardArrowRight color="#fff" size={25} />
                              </span>
                            </div>

                          </div>
                        </div>
                      )} />
                  </div>

                </div>
                <div className='search-section d-flex  pe-1 pe-lg-0 from-date-search'>
                  <div className='search-div  from-date-search'>
                    <DatePicker selected={endDate} className='search-input' placeholderText="To Date"
                      onChange={(EnDate) => {
                        setEndDate(EnDate)
                      }}
                      calendarClassName="custom-calendar"
                      renderCustomHeader={({
                        date,
                        decreaseMonth,
                        increaseMonth,
                        prevMonthButtonDisabled,
                        nextMonthButtonDisabled,
                      }) => (
                        <div className="custom-header">
                          <div className="custom-header-top">
                            <div className="day">
                              {date.toLocaleDateString("en-US", {
                                weekday: "short",
                                month: "short",
                                day: "numeric",
                              })}
                            </div>
                          </div>
                          <div className="custom-month-nav">

                            <span className="month-year">
                              {date.toLocaleString("default", { month: "long" })} {date.getFullYear()}
                            </span>
                            <div>
                              <span onClick={decreaseMonth} disabled={prevMonthButtonDisabled} className="btn-picker">
                                <MdKeyboardArrowLeft color="#fff" size={25} />
                              </span>
                              <span onClick={increaseMonth} disabled={nextMonthButtonDisabled} className="btn-picker">
                                <MdOutlineKeyboardArrowRight color="#fff" size={25} />
                              </span>
                            </div>

                          </div>
                        </div>
                      )} />
                  </div>
                  <FiSearch className='search-video-list'
                    onClick={() => {
                      setSearchFlag(true)
                      searchVideos()
                    }} />
                </div>
              </div>

            </div>
            {(userData?.roleDisplayName === `Super_admin` || userData?.roleDisplayName === "APPROVER") &&
              <div className='back-to' onClick={() => window.location.href = "/admin-list"}>
                Back
              </div>
            }
          </div>
        </div>
      </div>
      <div className="container mt-0 mt-md-3">
        <div className='text-end'>
          {userData?.roleDisplayName !== `APPROVER` &&

            <button className='accept-all-btn'
              onClick={() =>
                setIsDragFile(true)}>
              File Upload
            </button>

          }
          {(userData?.roleDisplayName === `Super_admin` || userData?.roleDisplayName === `Admin`) && (
            <>
              <button className='accept-all-btn mx-2' disabled={deleteMultiFlag || allSelectedVideos.length === 0}
                
                onClick={() => {
                  setSelectedToDelete(allSelectedVideos)
                  setIsDelete(true)
                  setDeleteMode("multiple")
                // deleteList(allSelectedVideos, "multiple")
                }}>
                {deleteMultiFlag ? "Deleting..." : "Delete"}
              </button>
              <button className='accept-all-btn' disabled={tagMultiFlag || allSelectedVideos.length === 0}
                onClick={() => generateTagPopup(allSelectedVideos, "", "multiple")}>
                Regenerate Tag
              </button>
            </>
          )}
        </div>
        <div className="row mt-2">
        {isDelete &&
         <div className="modal-admin-wrapper multiple-upload" >        
          <div className="modal-ad-popup modal-md">
            <div className="modal-innerpopup ">
              <div className="modal-headdiv d-flex justify-content-between">
                <h5 className="modal-head w-100 text-center">Do you want to delete?</h5>
                {/* <span className="closeBtn"><IoCloseOutline size={32} onClick={() => cancelpopup()} /></span> */}
              </div>
            </div>
            <div className="tag-popup-footer">
              <div className="d-flex align-items-center gap-2">
                <button
                  type="button"
                  className="accept-all-btn w-100 py-2 accept-all-gray"
                 onClick={() => deletePopupCancel()}
                >
                  Cancel
                </button>

                <button
                  type="button"
                  className="accept-all-btn w-100 py-2 d-flex align-items-center gap-2 justify-content-center"
                 onClick={() =>deleteList()}
                >
                  Ok
                </button>
              </div>
            </div>
          </div>
          </div>}
          <div className={` position-relative ${userData?.roleDisplayName === `APPROVER` ? `col-lg-12` : `col-lg-12`}`}>
            {loading === false ?
              videoListCount > 0 ?
                <div className='table-responsive'>
                  <table className="table table-bordered admin-list-table">
                    <thead>
                      <tr>
                        <th className='text-center position-relative'>
                          {videoList.filter(item => item.videoStatus !== "Processing").length > 0 && (
                            <div className='checkbox-mark' style={{ left: "auto" }}>
                              <div className="checkbox-wrapper-1">
                                <input
                                  id="select-all-checkbox"
                                  className="substituted"
                                  type="checkbox"
                                  checked={isAllChecked()}
                                  onChange={handleSelectAllChange}
                                  ref={input => {
                                    if (input) {
                                      input.indeterminate = isSomeChecked();
                                    }
                                  }}
                                />
                                <label htmlFor="select-all-checkbox"></label>
                              </div>
                            </div>
                          )}
                        </th>

                        <th className='col-md-5 col-xxl-6' style={{ minWidth: "200px", whiteSpace: 'nowrap' }}>Title / Description</th>
                        <th > Details </th>
                        {userData?.roleDisplayName === `Admin` &&
                          <th className='text-center'>Approval</th>
                        }
                        <th className='text-center'>Status</th>
                        {userData?.roleDisplayName !== `APPROVER` &&
                          <th className='text-center' style={{ width: "70px" }} colSpan={2}>Actions</th>
                        }
                      </tr>
                    </thead>
                    <tbody>
                      {videoList.map((data, i) => {
                        return (
                          <tr key={i}>
                            <td className='text-center position-relative'>
                              {data.videoStatus !== "Processing" && (
                                <div className='checkbox-mark' style={{ left: "auto" }}>
                                  <div className="checkbox-wrapper-1">
                                    <input
                                      type="checkbox"
                                      id={`checkbox-${data.video_id}`}
                                      className="substituted"
                                      checked={allSelectedVideos.includes(data.video_id)}
                                      onChange={(e) => handleCheckboxChange(e, data.video_id)}
                                    />
                                    <label htmlFor={`checkbox-${data.video_id}`}></label>
                                  </div>
                                </div>
                              )}
                              {(offset * 1) + i + 1}
                            </td>
                            <td style={{ wordBreak: "break-all" }}>
                              {data.video_heading}
                              <p className='small text-muted' title={data.description}>{data.description}</p>
                              {data.url && (
                                <div>
                                  <span className='play-btn' onClick={() => {
                                    popupTagShow(data)
                                  }}>
                                    {data.fileTypeId == "1" ?
                                      <FaImage className='cursor-pointer' size={13} />
                                      :
                                      <FaVideo className='cursor-pointer' size={13} />
                                    }
                                  </span>
                                </div>
                              )}
                            </td>
                            <td >
                              <div className='table-sides'>
                                <div>
                                  <div>{data.userDisplayName} </div>
                                  <div className='sub-text'>{data.userEmailId}</div>
                                  <div className='sub-text'>
                                    {(userData?.roleDisplayName === `Super_admin` || userData?.roleDisplayName === "APPROVER") ? data.videoCreatedOn : moment(data.videoCreatedOn).format('DD-MM-YYYY')}
                                  </div>
                                </div>
                              </div>
                            </td>
                            {userData?.roleDisplayName === `Admin` &&
                              <td className='text-center'>
                                <button className={`status-btn cursor-default 
                                  ${data.approveStatus === "Open" ? "status-pending"
                                    : data.approveStatus === "Rejected" ? "status-reject" : ""}`}>
                                  {data.approveStatus}
                                </button>
                              </td>
                            }
                            <td className="text-center">
                              <button id={`status-btn${i}`}
                                className={`status-btn cursor-default ${data.videoStatus == "Processing" ? "status-processing" : (data.videoStatus === "Open"
                                  && "status-pending"
                                )}`}
                              >
                                {data.videoStatus == "Processing" ? `Processing...` : (data.videoStatus === "Open" ? "Pending" : data.videoStatus)}
                              </button>
                            </td>
                            <td className='text-center'>
                              {data.videoStatus === "Processed" &&
                                <button className='view-deatils-list text-dark mb-2 w-100' onClick={() => proessedDetailsPopup(data)} style={{ whiteSpace: "nowrap" }}>View Details</button>
                              }
                              <button className='view-deatils-list w-100' id={`tag-btn${i}`}
                                style={{
                                  textDecoration: data.videoStatus === "Processing" ? "none" : "underline",
                                  whiteSpace: "nowrap"
                                }}
                                disabled={data.videoStatus == "Processing"}
                                onClick={() => {
                                  generateTagPopup([data.video_id], i, "single", data)
                                }}
                              >
                                {data.videoStatus === "Processed" ? `Regenerate Tag` : data.videoStatus === "Processing" ? `Processing...` : `Generate Tag`}
                              </button>
                              {userData?.roleDisplayName !== `APPROVER` &&
                                <div className='d-flex align-items-center gap-2 justify-content-center mt-2'>
                                  {data.videoStatus == "Processed" && (
                                    <MdOutlineEdit className='theme-color cursor-pointer' size={24}
                                      onClick={() => listPopup(data, "Edit", i)} />
                                  )}
                                  <button className="editIcon"
                                    onClick={(e) => {
                                      setSelectedToDelete([data.video_id]);
                                      setIsDelete(true)
                                      setDeleteMode("single")
                                      //deleteList([data.video_id], "single")
                                    }}>
                                    <RiDeleteBinLine className='text-danger cursor-pointer' size={17} />
                                  </button>
                                </div>
                              }
                            </td>
                            {/* {userData?.roleDisplayName !== `APPROVER` &&
                              <td>
                                {data.videoStatus == "Processed" && (
                                  <MdOutlineEdit className='theme-color cursor-pointer mt-2' size={24}
                                    onClick={() => listPopup(data, "Edit", i)} />
                                )}
                                <button className="editIcon"
                                  onClick={(e) => {
                                    deleteList([data.video_id], "single")
                                  }}>
                                  <RiDeleteBinLine className='text-danger cursor-pointer' size={17} />
                                </button>
                              </td>
                            } */}
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                  {videoListCount > itemsCountPerPage ?
                    <div className='pagination-wrapper mt-4'>
                      <Pagination
                        activePage={activePage}
                        itemsCountPerPage={itemsCountPerPage}
                        totalItemsCount={videoListCount}
                        pageRangeDisplayed={itemsCountPerPage}
                        onChange={(e) => handlePageChange(e)}
                      />
                    </div>
                    : ""
                  }
                </div>
                :
                <div className="noData d-flex flex-column">
                  <div>
                    <img src={noData} alt="noData" className="img-fluid" width="150" height="150" />
                  </div>
                  <div>No Data Available</div>
                </div>

              :
              <div className="noData d-flex flex-column">
                <div>
                  <img src={Loader} alt="noData" className="img-fluid" width="150" height="150" />
                </div>
              </div>
            }
            {proessedPopup &&
              <GenerateTag processedVideoId={processedVideoId} cancelPopup={cancelPopup} />
            }
          </div>
        
          {(userData?.roleDisplayName !== `APPROVER` && isDragFile) &&

            <div className="col-lg-3 order-1 order-md-1">
              <Videomultipleupload
                videoListFn={() => videoListFn(userName, videoName, startDate, endDate, offset, fileType,true)} getCloudBucketData={getCloudBucketData} userData={userData} setIsDragFile = {setIsDragFile}/>
            </div>
          }
        </div>
      </div>

      {deleteMultiFlag &&
        <div className="loader-div flex-column">
          <div>
            <img src={Loader} alt="noData" className="img-fluid" width="150" height="150" />
            <p className='text-center'>Deleting video....</p>
          </div>
        </div>
      }
      {ImagePopup
        &&
        <ImagePopups cancelPopup={cancelPopup} selectData={popupSelectData} />
      }
      {popupList &&
        <ListUpload userData={userData}
          cancelPopup={cancelPopup} getData={() => videoListFn(userName, videoName, startDate, endDate, offset, fileType,true)} getCloudBucketData={getCloudBucketData} sendMail={sendMail} selectData={selectData} mode={mode} selectIndex={selectIndex} />
      }
    </div>
  )
}

export default VideoList